import moment from 'moment';

function getDateSinceMidnight(seconds: number): Date {
  return new Date(moment().startOf('day').valueOf() + seconds * 1000);
}

export { getDateSinceMidnight };
